/*----------------------------------
- PUBLIC TABLE IDENTITY HELPERS
----------------------------------*/

/**
 * @docs docs/features/website-domains-hubs
 *
 * The name split shared by the table's name cell, the phone card and the row drawer (and, until batch 4 rebuilds
 * them, the /auctions and /registrars preview drawers' frame). The row icon tiles it also held left with the design
 * system: the row's mark is now the kit `Glyph`, coloured by `pickCardSeed` (`cardVisuals.ts`).
 */

/**
 * Name and suffix, split at the registrable boundary.
 *
 * Split at the last dot rather than the first: `co.uk` is one suffix, and splitting at the first
 * dot would print the name as `example` with a `.co.uk` that is not what the row carries.
 */
export const splitDomainLabel = (value: string): { name: string; tld: string } => {
    const separatorIndex = value.lastIndexOf('.');
    if (separatorIndex <= 0 || separatorIndex === value.length - 1) return { name: value, tld: '' };
    return { name: value.slice(0, separatorIndex), tld: value.slice(separatorIndex) };
};
